import Molde from "./MoldeTourTradicionalTrek";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import React from 'react';


export default function MontaniaColores() {
  return (
    <>
      <Molde
        image={"/images/montania-7-colores-portada.png"}
        title={"MONTAÑA DE 7 COLORES"}
        subtitle={"(FULL DAY)"}
        description={
          "La montaña de los 7 Colores (también llamado Vinicunca o simplemente ‘montaña arcoíris’) es una de las nuevas y mejores atracciones del Perú. Ubicada a más de 100 kilómetros de la ciudad del Cusco, en una cumbre altitudinal situada a 5,200 metros sobre el nivel del mar (m.s.n.m.). Se trata de una formación montañosa teñida de varias tonalidades producto de la compleja combinación de minerales. Las laderas y la cumbre están teñidas de diversas tonos que incluyen el rojo, morado, verde, amarillo, rosado y otras variaciones. Este atractivo turístico estuvo rodeado de hielo hace no muchos años. Desde el 2016, este lugar recibe a cientos de visitantes al día convirtiéndose, junto con Machu Picchu, en uno de los lugares más visitados en Cusco-Perú. A continuación toda la información sobre la Montaña de 7 Colores."
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 40.00"}
        moneda={"DOLARES"}*/
        mapa={
          <>
            <div>
              <h1 className="text-primary-800 font-bold">UBICACIÓN</h1>
            </div>
            <img className="rounded-lg border-primary-800 border-2" src={`${process.env.PUBLIC_URL}/images/mapa_7_colores.png`} alt="" />
          </>
        }
        galeria={
            <>
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_1.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_2.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_3.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_4.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_5.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_6.png`} alt="" />
            </>
          }
        incluye={
          <>
            <li>Transporte turistico</li>
            
            <li>Asistencia permanente</li>
            <li>Desayuno buffet</li>
            <li>Almuerzo buffet</li>
          </>
        }
        noIncluye={
          <>
            <li>Pago de ingreso</li>
            <li>Alquiler de caballo</li>
            <li>Gastos extra</li>
          </>
        }
        recomendaciones={
          <>
            <li>Bloqueador solar.</li>
            <li>Poncho en caso de lluvia.</li>
            <li>Gorra, sombrero, guantes, lentes de sol.</li>
            <li>Botella con agua.</li>
            <li>Cortavientos, pantalón de trekking.</li>
            <li>Zapatillas ideales para trekking.</li>
            <li>Snacks, cámara fotográfica, documentos, dinero extra.</li>
          </>
        }
        caracteristica={
          <>
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
              title={"Dificultad"}
              desc={"Dificil"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
              title={"Tipo Servicio"}
              desc={"Compartido"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
              title={"Duración"}
              desc={"Full day"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
              title={"Tipo de Tour"}
              desc={"Trek"}
            />
          </>
        }
        lugarvisita={
          <>
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Cusipata"}
            />
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Vinicunca"}
            />
            
          </>
        }
        TourRecomienda={
                  <>
                    <CardRecomienda
                      img={"/images/montania_colores.png"}
                      title={"MONTAÑA 7 COLORES"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/montania-colores'}
                    />
                    <CardRecomienda
                      img={"/images/valle-vip-5.png"}
                      title={"VALLE VIP"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/valle-vip'}
                    />
                    <CardRecomienda
                      img={"/images/cris-1.png"}
                      title={"CITY TOUR"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/citytour'}
                    />
                    <CardRecomienda
                      img={"/images/maras-moray-4.png"}
                      title={"MARAS-MORAY"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/maras-moray'}
                    />
                  </>
                }
      />
    </>
  );
}
